
import aframe from "aframe"

aframe.registerComponent('frame-button', {
    schema: {
        button: {
            type: 'boolean',
            default: false,
        },

        id: {
            type: 'string',
            default: ""
        },

        cursorFeedback: {
            type: 'boolean',
            default: true,
        },
    },
    
    init: function() {

        this.hovered = false
        this.clikedDown = false

        this.clickDownBinded = this.clickDown.bind(this)
        this.clickUpBinded = this.clickUp.bind(this)

        this.cursorEnterBinded = this.cursorEnter.bind(this)
        this.cursorLeaveBinded = this.cursorLeave.bind(this)

        this.elClickBinded = this.elClick.bind(this)

        this.cursor = document.querySelector("#main-cursor") 

        this.el.addEventListener("mouseenter", this.cursorEnterBinded)
        this.el.addEventListener("mouseleave", this.cursorLeaveBinded)

        this.el.sceneEl.addEventListener('mousedown', this.clickDownBinded)
        this.el.sceneEl.addEventListener('mouseup', this.clickUpBinded)

        this.el.sceneEl.addEventListener('touchstart', this.clickDownBinded)
        this.el.sceneEl.addEventListener('touchend', this.clickUpBinded)

        this.el.sceneEl.addEventListener('gamepadbuttondown', this.clickDownBinded)
        this.el.sceneEl.addEventListener('gamepadbuttonup', this.clickUpBinded)

        this.el.addEventListener("click", this.elClickBinded)
    },

    remove: function () {
        this.el.removeEventListener("mouseenter", this.cursorEnterBinded)
        this.el.removeEventListener("mouseleave", this.cursorLeaveBinded)

        this.el.sceneEl.removeEventListener('mousedown', this.clickDownBinded)
        this.el.sceneEl.removeEventListener('mouseup', this.clickUpBinded)

        this.el.sceneEl.removeEventListener('touchstart', this.clickDownBinded)
        this.el.sceneEl.removeEventListener('touchend', this.clickUpBinded)

        this.el.sceneEl.removeEventListener('gamepadbuttondown', this.clickDownBinded)
        this.el.sceneEl.removeEventListener('gamepadbuttonup', this.clickUpBinded)

        this.el.removeEventListener('click', this.elClickBinded)
    },

    cursorEnter: function () {
        this.hovered = true

        this.el.emit("cursorEnter")
        if (this.data.cursorFeedback) this.cursor.emit("cursorEnter")
    },

    cursorLeave: function () {
        this.hovered = false

        this.el.emit("cursorLeave")
        if (this.data.cursorFeedback) this.cursor.emit("cursorLeave")
    },

    clickDown: function () {
        if (!this.hovered) return

        this.clickDown = true
        this.el.emit("clickDown")
    },

    clickUp: function () {
        if (this.data.button) {

            if (!this.hovered || !this.clickDown) return

            this.clickDown = false
            this.el.emit("clickUp")

        } else {
            this.el.emit("clickUp")
        }
    },

    elClick: function () {
        // console.log("Clickng on it ;)")
        this.el.emit("clickEl")
    }
})


// WEBPACK FOOTER //
// ./src/components-aframe/frameButton.js